module.exports = __webpack_public_path__ + "images/6cdcb665c0fd8669f3abf572979e5c7d.svg";